// InstrumentRegistry.js
// Central metadata registry for clinical instruments (future-safe)
// NOTE: Routing is unchanged for now; this provides a single source of truth
// for titles, grouping, and canonical route slugs per instrument key.

export const instrumentRegistry = {
  baarsIVCurrentInformant: {
    title: 'Their Symptoms in Adulthood',
    group: 'adhd_adulthood',
    routeSlug: 'their-symptoms-in-adulthood',
  },
  asrsOAdulthoodInformant: {
    title: 'Their Symptoms in Adulthood',
    group: 'adhd_adulthood',
    routeSlug: 'their-symptoms-in-adulthood', // same route as BAARS-IV adulthood
  },
  baarsIVChildhoodInformant: {
    title: 'Their Symptoms in Childhood',
    group: 'adhd_childhood',
    routeSlug: 'their-symptoms-in-childhood',
  },
  snapIVChildhoodInformant: {
    title: 'Their Symptoms in Childhood',
    group: 'adhd_childhood',
    routeSlug: 'their-symptoms-in-childhood', // keep current friendly route
  },
  // add patient/self instruments here as needed
};

// Returns a user-facing title for a formKey
export const getInstrumentTitle = (formKey) => {
  return instrumentRegistry[formKey]?.title || formKey;
};

// Returns a route path for an instrument form (current friendly scheme)
// Future: switch to `/scales/:formKey` when ready.
export const getInstrumentPath = (formKey) => {
  const slug = instrumentRegistry[formKey]?.routeSlug;
  if (!slug) return null;
  return `/scales/${slug}`;
};

// Returns instrument group key (for grouping in dashboards)
export const getInstrumentGroup = (formKey) => {
  return instrumentRegistry[formKey]?.group || null;
};


